import type { PaginationState, Updater } from '@tanstack/react-table';
import { TableFooter } from '@/shared/ui/AppTable';
import styles from '../../dashboard/Dashboard.module.scss';

interface AnalyticsPaginationProps {
  page?: number;
  pageCount?: number;
  pageSize?: number;
  onPageChange?: (page: number) => void;
}

export const AnalyticsPagination = ({
  page,
  pageCount,
  pageSize = 8,
  onPageChange,
}: AnalyticsPaginationProps) => {
  if (page === undefined || pageCount === undefined || pageCount <= 1) return null;

  const paginationState: PaginationState = { pageIndex: page - 1, pageSize };

  const handleChange = (updater: Updater<PaginationState>) => {
    const next = typeof updater === 'function' ? updater(paginationState) : updater;
    onPageChange?.(next.pageIndex + 1);
  };

  return (
    <TableFooter total={pageCount} pagination={paginationState} setPagination={handleChange} />
  );
};

interface AnalyticsSubTabsProps {
  tabs: { key: string; label: string }[];
  value: string;
  onChange: (key: string) => void;
}

export const AnalyticsSubTabs = ({ tabs, value, onChange }: AnalyticsSubTabsProps) => (
  <div className={styles.subTabsRow} role="tablist">
    {tabs.map((tab) => {
      const active = tab.key === value;
      return (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={active}
          className={`${styles.subTab} ${active ? styles.subTabActive : ''}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);
